import React from 'react';
import Email from '@/components/Email/index';
import {Avatar, Tag} from 'antd';

/**
 * This is not a component,
 * it is a function to render the Email component in a table cell
 * */
export const renderEmail = (email, item) => <Email item={item}>{email}</Email>;


/**
 * This is not a component,
 * it is a function to render the Avatar component in a table cell
 * */
export const renderAvatar = (avatar) => <Avatar src={avatar}/>;

/**
 * This is not a component,
 * it is a function to render the Squared Avatar component in a table cell
 * */
export const renderSquareAvatar = (avatar) => <Avatar shape="square" src={avatar}/>;


export const renderTag = (value) => <Tag>{value}</Tag>;
